<template>
  <router-view></router-view>
</template>

<script>
export default {
	name: 'Cliente',
	title: 'Cliente'
}
</script>

<style scoped>
</style>
